/** Type of MainSMS account. Defines limits usage. */
export enum MainSmsAccountTypeEnum {
  /** Constant account - created manually by user. Paying for an account and its limitations are the user's problems, not ours. */
  CONSTANT = 'CONSTANT',
  /** Temporary account - created automatically on tenant creation. This is our account and we are introducing limits on its use for the user. */
  TEMPORARY = 'TEMPORARY',
}
